import { c as _c } from "react/compiler-runtime";
import Button from '../../../../common/base/Button';
import Text from '../../../../common/base/Text';
import { Div } from '../../../../common/helpers/StyledUtils';
import { CLIOnboardingContext } from '../GuidedCLIOnboarding';
import Keybinds from '../../../../common/base/Keybinds';
import { StyledCard, StyledCardSection } from '../../../../common/base/Card';
import Tabs from '../../../../common/base/Tabs';
import { useState } from 'react';
interface Props {
  context: CLIOnboardingContext;
  mutateContext: (input: Partial<CLIOnboardingContext>) => void;
  nextStep: () => void;
  is_current_step: boolean;
}
const Key = t0 => {
  const $ = _c(4);
  const {
    keys
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "inline"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "inline-block"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== keys) {
    t3 = <Div style={t1}><Keybinds keys={keys} style={t2} /></Div>;
    $[2] = keys;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
const options = {
  inspect_and_debug: {
    label: 'Inspect and debug',
    tips: [<Text key="shortcut">
        <Key keys={['D']} /> to view full request/response details for the selected event
      </Text>, <Text key="shortcut">
        <Key keys={['↑']} /> / <Key keys={['↓']} /> or <Key keys={['K']} /> / <Key keys={['J']} />{' '}
        to navigate between webhook events
      </Text>, <Text key="shortcut">
        <Key keys={['O']} /> to open an event in the dashboard for deeper inspection
      </Text>]
  },
  retry_webhook_events: {
    label: 'Retry webhook events',
    tips: [<Text key="shortcut">
        <Key keys={['↑']} /> / <Key keys={['↓']} /> or <Key keys={['K']} /> / <Key keys={['J']} />{' '}
        to select the event you want to retry
      </Text>, <Text key="shortcut">
        <Key keys={['R']} /> to instantly retry the selected event to your local server
      </Text>, <Text key="shortcut">
        <Key keys={['D']} /> to see full request/response data
      </Text>]
  }
};
const SetupComplete: React.FC<Props> = () => {
  const $ = _c(16);
  const [active_tab, setActiveTab] = useState("inspect_and_debug");
  const option = options[active_tab];
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Object.entries(options).map(_temp);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = key_0 => setActiveTab(key_0 as keyof typeof options);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      t: 2,
      x: 3
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== active_tab) {
    t3 = <StyledCardSection><Tabs tabs={t0} active_tab={active_tab} onTabSelected={t1} compact={true} border={false} m={t2} /></StyledCardSection>;
    $[3] = active_tab;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      direction: "column",
      gap: 2
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== option.tips) {
    t5 = option.tips.map(_temp2);
    $[6] = option.tips;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <StyledCardSection><Div p={2} flex={t4}>{t5}</Div></StyledCardSection>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <StyledCard overflow_hidden={true}>{t3}{t6}</StyledCard>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Div m={{
      t: 8
    }}><Button primary={true} icon="arrow_forward" to="/connections">Proceed to dashboard</Button></Div>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7) {
    t9 = <Div>{t7}{t8}</Div>;
    $[14] = t7;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
export default SetupComplete;
function _temp(t0) {
  const [key, option_0] = t0;
  return {
    key,
    label: option_0.label
  };
}
function _temp2(tip) {
  return <StyledCard key={tip.key} overflow_hidden={true}><StyledCardSection m={0} p={{
      x: 3,
      y: 3
    }} muted={true}>{tip}</StyledCardSection></StyledCard>;
}